import { httpClient } from '@/lib/http-client'

export const maturityLevelsApi = {
    getAll: () => httpClient.get('/maturity-levels'),
    create: (data: any) => httpClient.post('/maturity-levels', data),
    update: (level: number, data: any) =>
        httpClient.put(`/maturity-levels/${level}`, data),
    delete: (level: number) =>
        httpClient.delete(`/maturity-levels/${level}`),
    importData: (form: FormData) =>
        httpClient.post('/maturity-levels/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/maturity-levels/export?format=${format}`,
}
